import './assets/main.css'
import '@fortawesome/fontawesome-free/css/all.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import router from './router'
import { sentryConfig, validateSentryConfig } from './config/sentry'
import { i18n, initializeI18n } from './plugins/i18n'

// Create Vue app instance
const app = createApp(App)

// Create Pinia store
const pinia = createPinia()

// Initialize Sentry if configuration is valid
if (validateSentryConfig()) {
  Sentry.init({
    app,
    ...sentryConfig,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      })
    ]
  })
  
  // Make Sentry available globally for helper functions
  if (typeof window !== 'undefined') {
    window.Sentry = Sentry
  }
}

// Register Pinia, i18n, and router
app.use(pinia)
app.use(i18n)
app.use(router)

// Initialize auth state and i18n on app startup
import { useAuthStore } from '@/stores/auth'
const authStore = useAuthStore()
authStore.checkAuthState()

// Initialize i18n with language detection
initializeI18n()

// Global error handler
app.config.errorHandler = (error, instance, info) => {
  console.error('Vue error:', error, info)
  
  // Send to Sentry if available
  if (typeof window !== 'undefined' && window.Sentry) {
    window.Sentry.withScope((scope: any) => {
      scope.setContext('vue', {
        componentName: instance?.$options.name || 'Unknown',
        errorInfo: info
      })
      window.Sentry.captureException(error)
    })
  }
}

// Mount the app
app.mount('#app')
